<main>
    <section class="background"></section>
    <section class="introduction">
        <section class="text">
            <h1>Hallo!</h1>
            <h2>My name is <b>Anouska de Graaf</b> and I'm a Software Engineer and UX Designer currently working at Rijkswaterstaat</h2>
            <a [routerLink]="['about']"><img src="../../../assets/icons/about.svg" alt="Icon About" />Learn more about me</a>
        </section>
    </section>
</main>